import { AdminFeatureFlagsName } from './name';
import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { getAdminFeatureFlagsSlice } from './get';
import { PatchAdminFeatureFlagByIdRequest } from '../../api';

export const updateAdminFeatureFlagSlice = createUpdateSyncSlice({
	name: AdminFeatureFlagsName,
	state: getAdminFeatureFlagsSlice.asyncState,
	transform: (action: PatchAdminFeatureFlagByIdRequest, state = {
		featureFlags: [],
		totalCustomerCount: 0 }) => {
		const index = state.featureFlags.findIndex((flag) => flag.name === action.id);

		if (index === -1) {
			return state;
		}

		const target = state.featureFlags[ index ];

		if (!target) {
			return state;
		}

		return {
			featureFlags: [
				...state.featureFlags.slice(0, index),
				{
					...target,
					enabledByDefault: action.defaultValue ?? target.enabledByDefault,
					groupId: action.groupId ?? target.groupId,
					groupName: action.groupName ?? target.groupName,
					state: action.forcedValue ?? target.state
				},
				...state.featureFlags.slice(index + 1)
			],
			totalCustomerCount: state.totalCustomerCount
		};
	}
});
